<template>
  <div class="wrapper mt-2 mb-1/2" :class="accessories ? 'md:mt-0 text-2xl font-normal' : 'md:mt-0 md:mb-0 font-medium text-2xl'">
    <div :class="accessories ? 'flex' : ''">
      <div class="pricing-wrapper">
        {{ accessories ? '' : (activeProductKey.includes('CM') ? 'Starting at' : '') }}
        <template
          v-if="smallFleetOpportunity && isAccountCreatedAfterTitan"
        >
          <template
            v-if="salesPriceLocal !== listPriceLocal"
          >
            <span class=""
              >{{ currencySymbol.toUpperCase() }}{{ listPriceLocal }}</span
            >
            <span class=""
              >{{ currencySymbol.toUpperCase() }}{{ salesPriceFormattedPricing }} due at
              checkout</span
            >
          </template>
          <template v-else>
            <span class=""
              >{{ currencySymbol.toUpperCase() }}{{ salesPriceFormattedPricing }} due at
              checkout</span
            >
          </template>
          <br />
          <span
            v-if="activeProductInfo.defaultOffering.toLowerCase().includes('license')"
            class="roboto text-sm mt-1/2 leading-tight text-blue-dark"
          >
            Approximately {{ currencySymbol.toUpperCase() }}{{ Math.round(salesPriceFormattedPricing / 36) }}/month for 3 year license
          </span>
        </template>
        <template
          v-else-if="salesPriceLocal !== listPriceLocal"
        >
          <span class="roboto text-blue-dark" id="offer-list-price" :class="accessories ? 'font-normal' : 'font-medium'"
            >{{ currencySymbol.toUpperCase() }}{{ listPriceLocal }}</span
          >
          <span class="roboto leading-7 text-blue-dark" id="offer-sales-price" :class="accessories ? 'font-normal' : 'font-medium'"
            >{{ currencySymbol.toUpperCase() }}{{ salesPriceFormattedPricing }}<span class="font-bold roboto leading-7 text-blue-dark" id="offer-payment-term"
              >/{{ activeOffer.defaultPaymentTerm }}</span
            ></span
          >
        </template>
        <template v-else>
          <span class="roboto leading-7 text-blue-dark" id="offer-sales-price" :class="accessories ? 'font-normal' : 'font-medium'"
            >{{ currencySymbol.toUpperCase() }}{{ salesPriceFormattedPricing }}<span class="roboto leading-7 text-blue-dark" id="offer-payment-term" :class="accessories ? 'font-normal' : 'font-medium'"
              > / {{ activeOffer.defaultPaymentTerm }}
              {{ currencyIsoCode }}</span
            ></span
          >
        </template>
      </div>
      <div
        v-if="!isProductGenerallyAvailable && !activeProductKey.includes('CBL')"
        class="product-status-wrapper cursor-pointer relative"
        :class="[accessories ? '' : 'core-product-status', (activeOffer.productStatus === 'Out of stock' || activeProductKey === 'AG46 Battery Replacement Pack') && 'out-out-stock']"
        id="product-status"
        @mouseover="showDetail = true"
        @mouseleave="showDetail = false"
      >
        <div class="error-circle">!</div>
        <p>{{ activeOffer.productStatus }}</p>
        <div
          v-if="showDetail"
          class="status-details"
        >
          {{ webstoreContent.webstoreBody[snakeCase(activeOffer.productStatus)] }}
        </div>
      </div>
    </div>
    <div class="section-margin-1">
      <p
        class="font-medium roboto"
        v-if="activeProductInfo.advisoryMessage"
      >
        {{ activeProductInfo.advisoryMessage }}
      </p>
    </div>
  </div>
</template>
<script>
import { WebstoreResources } from '../../../../mixins/webstore-resources'
export default {
  mixins: [WebstoreResources],

  data() {
    return {
      showDetail: false,
    }
  },

  props: {
    accessories: {
      required: false,
      type: Boolean,
    },
  },

  computed: {

    // These functions take the lists of separate prices and combine them into on value to show
    salesPriceLocal() {
        return this.defaultOfferPricing ? this.calculateTotalPrice(this.defaultOfferPricing.salesPrice) : '';
    },

    listPriceLocal() {
      return this.defaultOfferPricing ? this.calculateTotalPrice(this.defaultOfferPricing.listPrice) : '';
    },

    isProductGenerallyAvailable() {
      if (this.activeProductKey === 'AG46 Battery Replacement Pack') {
        this.activeOffer.productStatus = "Out of stock";
        return true;
      }
      return this.activeOffer.productStatus === "GA";
    },

    activeOfferPricing() {
      if (this.activeOfferKey && this.activeOfferKey !== 'Cable') {
        return this.activeProductInfo.offerings[this.activeOfferKey]
      }
      else {
        return this.activeProductInfo.offerings[this.activeProductInfo.defaultOffering]
      }
    },

    defaultOfferPricing() {
      if(this.activeProductInfo.key.includes("CM") && !this.activeProductInfo.key.includes("ACC") && this.isPartnerAccount){
          return this.activeProductInfo.offerings["License + Hardware"]
      }
      let licenseOfferings = Object.values(this.activeProductInfo.offerings).filter((offering) => (offering.offerKey.includes("License + Hardware") && !offering.offerKey.includes("Add-on")))
      if (licenseOfferings.length) {
        return licenseOfferings.reduce((min, offering) => this.calculateTotalPrice(min.listPrice) < this.calculateTotalPrice(offering.listPrice) ? min : offering)
      } else {
        return this.activeOfferPricing
      }
    },

    salesPriceFormattedPricing() {
      if (this.defaultOfferPricing) {
        return Number.isInteger(this.salesPriceLocal)
          ? this.salesPriceLocal
          : this.salesPriceLocal.toFixed(2);
      } else {
        return this.activeOfferPricing
      }
    },
  },
};
</script>
<style lang="scss" scoped>
  #offer-list-price {
    -webkit-text-decoration-line: line-through; /* Safari */
    -webkit-text-decoration-color: #cd1426;
    -webkit-text-decoration-thickness: 2px;
    text-decoration-line: line-through;
    text-decoration-color: #cd1426;
    text-decoration-thickness: 2px;
    font-size: 20px;
    line-height: 28px;
    color: #00263e;
  }
  .small-fleet-list-price {
    -webkit-text-decoration-line: line-through; /* Safari */
    -webkit-text-decoration-color: #cd1426;
    -webkit-text-decoration-thickness: 2px;
    text-decoration-line: line-through;
    text-decoration-color: #cd1426;
    text-decoration-thickness: 2px;
    position: relative;
    font-size: 32px;
    line-height: 24px;
    color: #0184fb;
    font-weight: bold;
  }
  .small-fleet-sale-price {
    font-size: 32px;
    line-height: 24px;
    color: #0184fb;
    font-weight: bold;
  }
  #product-status {
    margin-top: 5px;
    margin-bottom: 0px;
    margin-left: 10px;
  }

  .pricing-wrapper {
    font-size: 20px !important;
    line-height: 1;
    color: #00263E !important;
    margin: 0;
    padding: 0;
  }

  .product-status-wrapper {
    width: fit-content;
    display: flex;
    height: 25px;
  }

  .product-status-wrapper p {
    color: #EE6917;
    font-weight: 600;
    font-size: 14px;
    margin: 0;
  }

  @media (max-width: 736px) {
    #product-status {
      margin: 0 auto;
      margin-top: 10px !important;
    }
  }

  .out-of-stock {
    color: #CD1426 !important;
  }

  .out-of-stock .error-cricle {
    background-color: #CD1426;
  }

  .out-of-stock .status-details {
    color: #CD1426;
    border: 1.5px solid #CD1426;
  }

  .core-product-status {
    margin: 0;
  }

  .error-circle {
    width: 16px;
    height: 16px;
    background-color: #EE6917;
    margin-right: 6px;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-weight: bold;
    font-size: 13px;
    margin-top: 1px;
  }

  .status-details {
    width: auto;
    white-space: nowrap;
    position: absolute;
    top: -85px;
    font-weight: 400px !important;
    border-radius: 2px;
    box-shadow: 0 1px 6px 1px rgba(0, 0, 0, 0.1);
    border: 1.5px solid #FEC7A4;
    background: #fff;
    padding: 5px 10px;
    max-width: 95vw;
    color: #EE6917;
    font-weight: 600;
    font-size: 14px;
  }
</style>
